import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Projects from "@/components/Projects";
import Matcher from "@/components/Matcher";
import Social from "@/components/Social";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import Admin from "@/pages/Admin";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { err: false };
  }
  static getDerivedStateFromError() {
    return { err: true };
  }
  render() {
    if (this.state.err) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-[#0B0C0E] text-[#F3E5AB]">
          Something went wrong — please refresh the page.
        </div>
      );
    }
    return this.props.children;
  }
}

const Page = () => (
  <div className="min-h-screen bg-ivory font-sans text-navy antialiased">
    <div className="grain-overlay" aria-hidden="true" />
    <Navbar />
    <main>
      <Hero />
      <Marquee />
      <Projects />
      <Matcher />
      <Social />
    </main>
    <Footer />
    <FloatingWhatsApp />
  </div>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = undefined;
    };
  }, []);

  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Page />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
        <Toaster position="top-center" />
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
